<template>
    <div class="add-or-edit-md-container">
        <van-nav-bar :title="isAdd ? '添加门店' : '编辑门店'" />
        <van-form class="md-form" validate-first :show-error-message="false" :show-error="true" @failed="onFailed" @submit="onSubmit">
            <van-field
                class="input-special-style"
                v-model="form.simpleName"
                name="simpleName"
                label="门店简称"
                placeholder="如“南门店，10字以内(必填)”"
                required
                :rules="[{ required: true, message: '请输入门店名称' }]"
            />
            <van-field class="custom-field-item" name="contact" label="业务/客服联系人">
                <template #input>
                    <van-row class="field-layout" gutter="10">
                        <van-col span="12">
                            <van-field
                                v-model="form.agentOne"
                                required
                                name="firstContact"
                                placeholder="联系人1姓名(必填)"
                                :rules="[{ required: true, message: '联系人1姓名(必填)' }]"
                            />
                        </van-col>
                        <van-col span="12">
                            <van-field
                                v-model="form.agentOnePhone"
                                required
                                name="firstCall"
                                type="tel"
                                placeholder="联系人1电话(必填)"
                                :rules="[
                                    { required: true, message: '联系人1姓名(必填)' },
                                    { validator: phoneValidator, message: '请输入正确的联系电话' }
                                ]"
                            />
                        </van-col>
                        <van-col span="12"
                            ><van-field v-model="form.agentTwo" name="secondContact" placeholder="联系人2姓名(选填)" />
                        </van-col>
                        <van-col span="12">
                            <van-field v-model="form.agentTwoPhone" name="secondCall" type="tel" placeholder="联系人2电话(选填)" />
                        </van-col>
                    </van-row>
                </template>
            </van-field>
            <van-field
                class="input-special-style"
                @click="gomap"
                v-model="form.fullAddress"
                name="fullAddress"
                label="门店地址"
                placeholder="请输入门店地址"
                required
                :rules="[{ required: true, message: '请输入门店地址' }]"
            >
            </van-field>
            <van-field class="custom-field-item" name="time" label="营业时间" required>
                <template #input>
                    <van-row class="field-layout">
                        <van-col span="10">
                            <van-field
                                readonly
                                clickable
                                name="openStartWeekname"
                                :value="form.openStartWeekname"
                                placeholder="每周开始时间"
                                required
                                :rules="[{ required: true, message: '请选择每周开始时间' }]"
                                @click="showStartWeekPicker = true"
                            />
                            <van-popup v-model="showStartWeekPicker" position="bottom">
                                <van-picker
                                    show-toolbar
                                    :columns="columns"
                                    value-key="name"
                                    @confirm="onConfirm($event, 'openStartWeek', 'openStartWeekname', 'showStartWeekPicker')"
                                    @cancel="showStartWeekPicker = false"
                                />
                            </van-popup>
                        </van-col>
                        <van-col class="interval" span="4">至</van-col>
                        <van-col span="10">
                            <van-field
                                readonly
                                clickable
                                name="openEndWeekname"
                                :value="form.openEndWeekname"
                                placeholder="每周结束时间"
                                required
                                :rules="[{ required: true, message: '请选择每周结束时间' }]"
                                @click="showEndWeekPicker = true"
                            />
                            <van-popup v-model="showEndWeekPicker" position="bottom">
                                <van-picker
                                    show-toolbar
                                    :columns="columns"
                                    value-key="name"
                                    @confirm="onConfirm($event, 'openEndWeek', 'openEndWeekname', 'showEndWeekPicker')"
                                    @cancel="showEndWeekPicker = false"
                                />
                            </van-popup>
                        </van-col>
                        <van-col span="10">
                            <van-field
                                readonly
                                clickable
                                name="openStartTime"
                                :value="form.openStartTime"
                                placeholder="每日开始时间"
                                required
                                :rules="[{ required: true, message: '请选择每日开始时间' }]"
                                @click="showStartTimePicker = true"
                            />
                            <van-popup v-model="showStartTimePicker" position="bottom">
                                <van-datetime-picker
                                    type="time"
                                    @confirm="onConfirmtime($event, 'openStartTime', 'showStartTimePicker')"
                                    @cancel="showStartTimePicker = false"
                                />
                            </van-popup>
                        </van-col>
                        <van-col class="interval" span="4">至</van-col>
                        <van-col span="10">
                            <van-field
                                readonly
                                clickable
                                name="openEndTime"
                                :value="form.openEndTime"
                                placeholder="每日结束时间"
                                required
                                :rules="[{ required: true, message: '请选择每日结束时间' }]"
                                @click="showEndTimePicker = true"
                            />
                            <van-popup v-model="showEndTimePicker" position="bottom">
                                <van-datetime-picker
                                    type="time"
                                    @confirm="onConfirmtime($event, 'openEndTime', 'showEndTimePicker')"
                                    @cancel="showEndTimePicker = false"
                                />
                            </van-popup>
                        </van-col>
                    </van-row>
                </template>
            </van-field>
            <div class="submit-btn-box">
                <van-button block type="info" native-type="submit" color="#FF6633">提交</van-button>
            </div>
        </van-form>
    </div>
</template>

<script>
import { Toast } from 'vant';
import { updateMallbranchstore, addMallbranchstore } from '../api/index';
export default {
    beforeRouteEnter(to, from, next) {
        if (from.name === 'map') {
            next((vm) => {
                vm.form = JSON.parse(localStorage.getItem('formData')); // 假设路由中传递了参数data
                vm.form.isAdd = to.query.isAdd;
                vm.form.fullAddress = to.query.fullAddress;
                vm.form.latitude = to.query.latitude;
                vm.form.longitude = to.query.longitude;
            });
        }
        next();
    },
    data() {
        return {
            form: {
                agentOne: '',
                agentOnePhone: '',
                agentTwo: '',
                agentTwoPhone: '',
                fullAddress: '',
                openStartWeek: '',
                openEndWeek: '',
                openStartTime: '',
                openEndTime: ''
            },
            isAdd: true, // 是否是编辑
            shortName: '', // 门店简称
            firstContact: '', // 联系人1姓名
            firstCall: '', // 联系人1电话
            secondContact: '', // 联系人2姓名
            secondCall: '', // 联系人2电话
            address: '', // 门店地址
            weekStart: '', // 每周开始时间
            weekEnd: '', // 每周结束时间
            timeStart: '', // 每日开始时间
            timeEnd: '', // 每日结束时间
            columns: [
                { name: '周一', id: 1 },
                { name: '周二', id: 2 },
                { name: '周三', id: 3 },
                { name: '周四', id: 4 },
                { name: '周五', id: 5 },
                { name: '周六', id: 6 },
                { name: '周日', id: 7 }
            ],
            showStartTimePicker: false,
            showEndTimePicker: false,
            showStartWeekPicker: false,
            showEndWeekPicker: false
        };
    },

    mounted() {
        this.isAdd = this.$route.query.isAdd === 'true';
        if (this.isAdd) {
            // 这是新增页面
            this.preview = true;
        } else {
            // 这是编辑页面
            if (this.$route.query.item) Object.assign(this.form, JSON.parse(this.$route.query.item));
            this.handPick();
        }
    },
    methods: {
        handPick() {
            this.columns.forEach((item) => {
                if (item.id === this.form.openStartWeek) this.form.openStartWeekname = item.name;
                if (item.id === this.form.openEndWeek) this.form.openEndWeekname = item.name;
            });
        },
        // Picker确认
        onConfirm(e, weekid, weekname, show) {
            this.form[weekname] = e.name;
            this.form[weekid] = e.id;
            this[show] = false;
        },
        onConfirmtime(e, time, show) {
            this.form[time] = e;
            this[show] = false;
        },
        onFailed(errorInfo) {
            console.log(errorInfo);
            Toast(errorInfo.errors[0].message);
        },
        onSubmit(values) {
            Object.assign(values, this.form);
            values.phone = this.$globalData.phone1;
            // 添加/编辑
            if (this.isAdd) {
                console.log('add', values);
                addMallbranchstore(values).then((res) => {
                    Toast(res.message);
                    this.$router.push('/md');
                });
            } else {
                console.log('edit', values);
                updateMallbranchstore(values).then((res) => {
                    Toast(res.message);
                    this.$router.push('/md');
                });
            }
        },
        // 验证手机号码
        phoneValidator(value) {
            const pattern = /^1[3456789]\d{9}$/;
            return pattern.test(value);
        },
        gomap() {
            localStorage.setItem('formData', JSON.stringify(this.form));
            this.$router.push({ path: '/map', query: { isAdd: this.isAdd } });
        }
    }
};
</script>

<style scoped lang="scss">
@mixin field-style {
    .van-field__control {
        height: 35px;
        background-color: #f5f5f5;
        padding: 0 10px;
        border-top-left-radius: 3px;
        border-bottom-left-radius: 3px;
    }
    .van-field__right-icon {
        height: 35px;
        line-height: 35px;
        background-color: #f5f5f5;
        border-top-right-radius: 3px;
        border-bottom-right-radius: 3px;
        color: #000000;
    }
}
.md-form {
    ::v-deep .van-cell {
        display: block;

        .van-cell__title {
            width: 100%;
            padding-left: 10px;
            font-size: 16px;
        }
        .van-cell__value .van-field__body {
            padding: 5px 0;
        }
    }

    ::v-deep .input-special-style .van-cell__value .van-field__body {
        @include field-style;
    }

    .custom-field-item .field-layout {
        ::v-deep .van-col .van-cell {
            padding: 0;
            .van-cell__value .van-field__body {
                @include field-style;
            }
        }

        .interval {
            line-height: 44px;
            text-align: center;
        }
    }

    .van-cell--required {
        &::before {
            left: 16px;
        }
        &::after {
            border: none;
        }
    }

    .upload-tip {
        padding: 5px 16px;
        font-size: 14px;
        color: #ff6633;
    }
    .submit-btn-box {
        padding: 16px;
    }
}
</style>
